// import footer from '@/components/student/footer'//公用底部

import userCenter from '@/components/student/user/center'//我的
import phoneSucceed from '@/components/student/user/phone-succeed'//修改手机号成功
import modifyPhone from '@/components/student/user/modify-phone'//修改手机号
import validatePhone from '@/components/student/user/validate-phone'//验证码手机号
import validateNewPhone from '@/components/student/user/validate-new-phone'//验证码手机号
import userReg from '@/components/student/user/reg'//注册绑定页面
import userSignPc from '@/components/student/user/sign-pc'//授课端签到
import userSignApp from '@/components/student/user/sign-app'//小组端签到
import userJoinClass from '@/components/student/user/join-class'//加入授课班
import userJoinGroup from '@/components/student/user/join-group'//加入小组，绑定小组和小组屏幕


export default [
	{
		path:'center',
		component(resolve) {
			require(['@/components/student/user/center'], resolve)
		},
		meta: {  
				title : '个人中心'
		}
	},
    {
		path:'audio',
		component(resolve) {
			require(['@/components/student/user/audio'], resolve)
		},
		meta: {  
				title : '测试语音'
		}
	},
    {
		path:'phone-succeed',
		component(resolve) {
			require(['@/components/student/user/phone-succeed'], resolve)
		},
		meta: {  
			title : '修改成功'
		}
    },
    {
		path:'modify-phone/:code',
		component:modifyPhone,
		meta: {  
			title : '修改号码'
		}
    },
    {
		path:'validate-phone/:phone',
		component:validatePhone,
		meta: {  
			title : '修改号码'
		}
    },
    {
		path:'validate-new-phone/:phone',
		component:validateNewPhone,
		meta: {  
			title : '修改号码'
		}
    },
    {
		path:'reg',
		component(resolve) {
			require(['@/components/student/user/reg'], resolve)
		},
		meta: {  
			title : '完善信息',
			isAuth : false
		}	
	},
	{
		path:'sign/pc/:schoolId/:coursewareId',//授课端签到
		component(resolve) {
			require(['@/components/student/user/sign-pc'], resolve)
		},
		meta: {  
			title : '大屏签到'
		}
	},
	{
		path:'sign/app/:schoolId/:mac/:coursewareId',//小组端签到
		component(resolve) {
			require(['@/components/student/user/sign-app'], resolve)
		},
		meta: {  
			title : '小组签到'
		}
	},
	{
		path:'join/class/:schoolId/:classId',//教师web，学生扫码加入班级
		component: userJoinClass,
		meta: {  
			title : '加入班级'
		}
	},
	{
		path:'join/group/:mac/:coursewareId',//小组端，学生扫码绑定设备和群组
		component: userJoinGroup,
		meta: {  
			title : '加入小组'
		}
	},
	{
		path:'join/group/:schoolId/:mac/:coursewareId',//小组端，学生扫码绑定设备和群组
		component: userJoinGroup,
		meta: {  
			title : '加入小组'
		}
  },
  {
    name:'emptyPage',
    path: 'empty-page',
    component(resolve) {
      require(['@/page/emptyPage'], resolve)
    },
    meta: {
      isAuth: false,
      title: ''
    }
  },
]




// WEBPACK FOOTER //
// ./src/router/student/user.js